/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APITypeEnum } from './APITypeEnum';
import {
    APITypeEnumFromJSON,
    APITypeEnumFromJSONTyped,
    APITypeEnumToJSON,
} from './APITypeEnum';

/**
 * Serializer for Ticket model.
 * @export
 * @interface APIPatchedTicketRequest
 */
export interface APIPatchedTicketRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedTicketRequest
     */
    user?: string;
    /**
     * 
     * @type {APITypeEnum}
     * @memberof APIPatchedTicketRequest
     */
    type?: APITypeEnum;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedTicketRequest
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedTicketRequest
     */
    message?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIPatchedTicketRequest
     */
    shared?: boolean;
}



/**
 * Check if a given object implements the APIPatchedTicketRequest interface.
 */
export function instanceOfAPIPatchedTicketRequest(value: object): value is APIPatchedTicketRequest {
    return true;
}

export function APIPatchedTicketRequestFromJSON(json: any): APIPatchedTicketRequest {
    return APIPatchedTicketRequestFromJSONTyped(json, false);
}

export function APIPatchedTicketRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedTicketRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'user': json['user'] == null ? undefined : json['user'],
        'type': json['type'] == null ? undefined : APITypeEnumFromJSON(json['type']),
        'subject': json['subject'] == null ? undefined : json['subject'],
        'message': json['message'] == null ? undefined : json['message'],
        'shared': json['shared'] == null ? undefined : json['shared'],
    };
}

export function APIPatchedTicketRequestToJSON(value?: APIPatchedTicketRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'user': value['user'],
        'type': APITypeEnumToJSON(value['type']),
        'subject': value['subject'],
        'message': value['message'],
        'shared': value['shared'],
    };
}

